import styled from "styled-components";
import { colors, types } from "../../../libs";
import { Modal } from "react-bootstrap";
import { XLg } from "react-bootstrap-icons";

export const NewBlockModal = styled(Modal)`
    .modal-width {
        max-width: 35%;
    }
    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    .modal-content {
        background-color: ${colors.background.lightBlack};
        border: none;
    }
`;

export const NewBlockModalHeader = styled(Modal.Header)`
    border-bottom: none;
    padding-bottom: 0;
`;

export const NewBlockModalTitle = styled(Modal.Title)`
    font-size: 1.5rem;
    color: ${colors.text.white};
`;

export const NewBlockModalBody = styled(Modal.Body)`
    padding-top: 0;
`;

export const NewBlockModalFooter = styled(Modal.Footer)`
    border-top: none;
    padding-top: 0;
    justify-content: flex-start;
    gap: 10px;
`;

export const Spacer = styled.div`
    height: 20px;
    background-color: ${colors.background.lightBlack};
`;

export const BlockTypeLabel = styled.label`
    display: block;
    ${types.body.normal};
    color: ${colors.text.white};
    font-weight: 500;
`;

export const BlockTypeList = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
`;

export const BlockTypeOption = styled.div`
    position: relative;

    input[type="radio"] {
        display: none;
    }

    label {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px;
        border: 2px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        background-color: ${colors.background.lightBlack};
        cursor: pointer;
        transition: all 0.2s ease;
    }

    input[type="radio"]:checked + label {
        border-color: ${colors.background.green};
        background-color: rgba(183, 248, 77, 0.1);
    }

    &:hover label {
        border-color: rgba(255, 255, 255, 0.4);
    }

    &.selected label {
        border-color: ${colors.background.green};
        background-color: rgba(183, 248, 77, 0.1);
    }
`;

export const RadioCircle = styled.div`
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    flex-shrink: 0;
    transition: all 0.2s ease;

    ${BlockTypeOption}:has(input[type="radio"]:checked) & {
        border-color: ${colors.background.green};
        background-color: ${colors.background.green};
        box-shadow: inset 0 0 0 3px ${colors.background.lightBlack};
    }
`;

export const OptionLabel = styled.span`
    flex: 1;
    ${types.body.normal};
    color: ${colors.text.white};
`;

export const OptionIcon = styled.div`
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    ${BlockTypeOption}:has(input[type="radio"]:checked) & {
        color: ${colors.background.green};
    }
`;

export const SelectPlaylistWrapper = styled.div<{ $isVisible: boolean }>`
    max-height: ${props => props.$isVisible ? '1000px' : '0'};
    overflow: ${props => props.$isVisible ? 'visible' : 'hidden'};
    transition: all 0.4s ease-in-out;
`;

export const CloseButton = styled(XLg)`
    &:hover {
        color: ${colors.background.green};
    }
    cursor: pointer;
`;

export const ErrorText = styled.div`
    color: ${colors.text.red};
    ${types.body.small};
    margin-bottom: 12px;
    `;